<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20" v-if="user">
      <div class="row">
        <div class="col-md-10 mb40">
          <h3>{{'Manage Gardens'|translate}}</h3>

          <div class="row">
            <div class="col-md-5 mt20">
              <router-link class="btn btn-info" :to="{ name: 'AddGarden'}">{{'Add garden'|translate}}</router-link>
              <!-- <router-link
                class="btn btn-info"
                :to="{ name: 'ManageSaleMarket'}"
              >{{'Manage Sale Market'|translate}}</router-link> -->
            </div>
            <div class="col-md-7 mt20">
              <input
                type="text"
                class="form-control"
                v-model="keyword"
                v-on:keypress.enter.prevent="search()"
                :placeholder="'Search'|translate"
              />
            </div>
          </div>

          <loading v-if="list_items == null" class="mt20" :text="'Please wait'|translate"></loading>

          <p
            class="mt20 alert alert-info"
            v-if="list_items && list_items.length == 0"
          >{{'There is no data'|translate}}</p>
          <table class="table mt10" v-if="list_items && list_items.length > 0">
            <thead>
              <tr>
                <th>{{'Name'|translate}}</th>
                <th>{{'Certificate'|translate}}</th>
                <th>{{'Address'|translate}}</th>
                <th>{{'Action'|translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item) in list_items" :key="item.id">
                <td>
                    {{item.name}}
                </td>
                <td>{{ item.certificate }}</td>
                <td>{{ item.full_address }}</td>

                <td>

                  <router-link

                    :to="{ name: 'EditGarden', params: { id: item.id }}"
                  ><i class="fas fa-pencil-alt fa-lg"></i></router-link>
                  &nbsp;&nbsp;
                  <a
                    class="danger"
                    v-on:click="removeItem(item)"
                    :disabled="removing"
                  ><i class="fas fa-trash fa-lg"></i></a>
                </td>
              </tr>
            </tbody>
          </table>
          <paginate
            v-if="total_page > 1"
            :page-count="total_page"
            :click-handler="clickPage"
            :prev-text="'Prev'|translate"
            :next-text="'Next'|translate"
            v-model="page"
            :container-class="'pagination'"
          ></paginate>
        </div>
        <profile-sidebar :user="user"></profile-sidebar>
      </div>
    </div>
  </div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'
import Paginate from 'vuejs-paginate'
import Loading from '@/components/elements/Loading'
import ProfileSidebar from '@/components/Profile/ProfileSidebar'
export default {
  name: 'Home',
  components: {
    MyHeader,
    Paginate,
    Loading,
    ProfileSidebar
  },
  data () {
    return {
      show_form: false,
      pass_data: null,
      list_items: null,
      removing: false,
      page: 1,
      user: null,
      offset: 0,
      keyword: '',
      limit: Utils.getLimit(),
      total_page: 1
    }
  },
  methods: {
    modalData (data) {
      this.list()
    },

    list () {
      let data = {
        page: this.page,
        limit: this.limit,
        keyword: this.keyword
      }

      Utils.requestV2(this, true)
        .get(`/gardens/?${Utils.arrayToRequestParam(data)}`)
        .then(response => {
          let data = response.data

          let list = data.data
          list = list.map(item => {
            let temp = new Date(parseInt(item.add_time) * 1000)
            item.add_date = this.$moment(temp)

            let temp1 = new Date(parseInt(item.start_time) * 1000)
            item.start_date = this.$moment(temp1)
            item.remain_text = Utils.getFormattedTime(this, item.add_date)
            return item
          })
          this.list_items = list

          this.total_page = Utils.getTotalPages(data.total)

          // update local storage
        })
        .catch(error => {
          this.updating = false
          Utils.showErrorMessage(this, error.response)
        })
    },

    removeItem (item) {
      this.$alertify.confirmWithTitle(
        this.$t('Confirm'),
        this.$t('Are you sure to remove this item ?'),
        () => {
          this.removing = true
          Utils.requestV2(this, true)
            .delete(`/gardens/${item.id}`)
            .then(response => {
              this.removing = false

              this.page = 1
              this.list()
              Utils.refreshUser(this)
            })
        }
      )
    },
    clickPage (pageNum) {
      console.log('pageNum', pageNum)
      this.page = pageNum
      this.list()
    },
    search () {
      console.log('keyword', this.keyword)
      this.page = 1
      this.list()
    }
  },
  mounted () {
    this.list()

    this.user = Utils.getUser(this)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cultivation/ManageGarden.vue